var $1f0ebacf5a0c0fa1$exports = {};
$1f0ebacf5a0c0fa1$exports = {
    "dropzoneLabel": `Zona spu\u{161}tanja`,
    "selectPlaceholder": `Odaberite stavku`,
    "tableResizer": `Promjena veli\u{10D}ine`,
    "colorSwatchPicker": `Color swatches`
};


export {$1f0ebacf5a0c0fa1$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
